import { Component, EventEmitter, Input, Output, CUSTOM_ELEMENTS_SCHEMA, ViewChild, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { CoilSheet, CoilSheetDataSets, Graph } from '../../shared/entities/coilSheet';
import { CommonModule, DatePipe } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { SplitterModule } from 'primeng/splitter';
import { DropdownButtonComponent } from '../dropdown-button/dropdown-button.component';
import { Utility } from '../../shared/entities/utils';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexYAxis,
  ApexFill,
  ApexMarkers,
  ApexStroke,
  NgApexchartsModule,
  ChartComponent
} from "ng-apexcharts";
import { ChartModule } from 'primeng/chart';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  yaxis: ApexYAxis;
  fill: ApexFill;
  stroke: ApexStroke;
  markers: ApexMarkers;
  colors: string[];
};

@Component({
  selector: 'app-coil-comparison',
  standalone: true,
  imports: [
    AgGridModule,
    CommonModule,
    SplitterModule,
    ChartModule,
    NgApexchartsModule,
    ButtonModule,
    DialogModule,
    FormsModule,
    DropdownButtonComponent
  ],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './coil-comparison.component.html',
  styleUrls: ['./coil-comparison.component.scss']
})

export class CoilComparisonComponent implements OnInit {
  selectedCoilsData: CoilSheet[] = [];
  ShowGraph: boolean = false;
  @ViewChild("chart", { static: false }) chart: ChartComponent | any;
  public chartOptions1!: Partial<ChartOptions> | any;
  public chartOptions2!: Partial<ChartOptions> | any;
  // Define Graph data by type
  dataSetMap: Map<string, Graph> = new Map<string, Graph>();
  matchDataWithGraph: CoilSheetDataSets[] = [];
  coilLength: number | undefined = 0;
  coilSheetId: string = '';
  // Graph
  selectedGraph: { key: string; label: string; } = { key: '', label: '' };
  availableGraphs: { key: string; label: string; }[] = [];
  selectedGraphData: CoilSheetDataSets = {};
  graphType: any;
  selectedCoils: CoilSheet[] = [];
  myCallback: any;

  // @Input() selectedCoils: CoilSheet[] = [];
  @Input() get showCoilComparisonDialog() {
    return this._showCoilComparisonDialog;
  }
  set showCoilComparisonDialog(value: boolean) {
    this._showCoilComparisonDialog = value;
  }
  private _showCoilComparisonDialog: boolean = false;

  @Output() displayChange = new EventEmitter();

  // Column Definitions: Defines & controls grid columns.
  colDefs: ColDef[] = [];
  regionMeasurementUnits: any = {};
  regionUnit: string = '';

  colors: string[] = ["#5e596f", "#A200A2", "#FF5DFF", "#F3B415", "#F27036", "#663F59", "#6A6E94", "#4E88B4", "#00A7C6", "#18D8D8", '#A9D794',
    '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
  ];

  constructor(private datePipe: DatePipe, private measurementsDataService: MeasurementsDataService) {
    this.regionMeasurementUnits = this.measurementsDataService.regionMeasurementUnits();
    this.measurementsDataService.getMeasurementsData.subscribe(unit => this.regionUnit = unit);
  }

  ngOnInit(): void {
    let unitRegion=''
    this.measurementsDataService.getMeasurementsData.subscribe(unit => unitRegion = unit);
    this.colDefs = [
      {
        field: "coilId", headerName: "Coil #", flex: 1, wrapHeaderText: true, cellRenderer: function (params: any) {
          return `<span><i style="font-size: initial; color: ${params.data.colors};" class="material-icons">circle</i></span>  ` + params.value
        }
      },
      { field: "width", headerName: `Average Width (${this.regionMeasurementUnits.width_thickness})`, flex: 1, wrapHeaderText: true },
      { field: "widthN", headerName: `Width range (incl. Tol.) (${this.regionMeasurementUnits.width_thickness})`, flex: 1, wrapHeaderText: true },
      { field: "thickness", headerName: `Average Thickness (${this.regionMeasurementUnits.width_thickness})`, flex: 1, wrapHeaderText: true ,
      valueGetter:function(params) {
        const value=params.data.thickness;
        if(unitRegion=="US_CUSTOMARY_UNITS") {
            return parseFloat(value).toFixed(3);
        } else {
            return parseFloat(value).toFixed(2);
        }
      } },
      { field: "thicknessN", headerName: `Thickness range (incl. Tol.)  (${this.regionMeasurementUnits.width_thickness})`, flex: 1, wrapHeaderText: true },
      { field: "shippingDate", headerName: "Despatch date", flex: 1, wrapHeaderText: true },
      { field: "length", headerName: `Length (${this.regionMeasurementUnits.length})`, flex: 1, wrapHeaderText: true },
      { field: "outsideDiameter", headerName: `Outside diameter (${this.regionMeasurementUnits.width_thickness})`, flex: 1, wrapHeaderText: true },
      { field: "weight", headerName: `Weight (${this.regionMeasurementUnits.weight})`, flex: 1, wrapHeaderText: true },
      { field: "orderdate", headerName: "Order date", flex: 1, wrapHeaderText: true, resizable: false }
    ];

    this.availableGraphs = [
      { key: "WIDTH_GRAPH", label: "Width" },
      { key: "THICKNESS_GRAPH", label: "Thickness" },
      { key: "CROWN_GRAPH", label: "Crown" },
      { key: "WEDGE_GRAPH", label: "Wedge" }
    ];
    this.selectedCoils = Utility.getSelectedCoilsFromLocalStorage();
    let countToCheckForCrownWedge = 0;
    this.selectedCoils.forEach(element => {
      if (element.availableDataSetNames?.includes('CROWN_GRAPH') || element.availableDataSetNames?.includes('WEDGE_GRAPH')) {
        countToCheckForCrownWedge = countToCheckForCrownWedge + 1;
      }
    });
    if (countToCheckForCrownWedge > 0) {
      this.availableGraphs = [
        { key: "WIDTH_GRAPH", label: "Width" },
        { key: "THICKNESS_GRAPH", label: "Thickness" },
        { key: "CROWN_GRAPH", label: "Crown" },
        { key: "WEDGE_GRAPH", label: "Wedge" }
      ];
    } else {
      this.availableGraphs = [
        { key: "WIDTH_GRAPH", label: "Width" },
        { key: "THICKNESS_GRAPH", label: "Thickness" }
      ];
    }
    this.selectedCoils.forEach((item, index) => {
      item.colors = this.colors[index];
    });
    if (this.selectedCoils && this.selectedCoils.length > 0) {
      this.onSelectGraphEvent(this.availableGraphs[0]);
      this.generateSelectedCoilsData(this.selectedCoils);
    }
  }


  generateSelectedCoilsData(selecteddata: CoilSheet[]) {
    this.selectedCoilsData = [];
    this.selectedCoilsData = selecteddata.map(coil => (
      {
        coilId: coil?.coilSheetId,
        width: coil?.width,
        widthN: this.widthTolerance(coil),
        thickness: this.coilThickenss(coil.thickness),
        thicknessN: this.thicknessTolerance(coil),
        shippingDate: this.datePipe.transform(coil.dateOfDelivery, 'dd-MM-yyyy'),
        length: coil?.length,
        outsideDiameter: coil?.outsideDiameter,
        weight: coil?.weight,
        orderdate: this.datePipe.transform(coil.orderDate, 'dd-MM-yyyy'),
        colors: coil?.colors
      }));
  }

  coilThickenss(thickness: any) {
    if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
      return +parseFloat(thickness).toFixed(3)
    } else {
      return +parseFloat(thickness).toFixed(2);
    }
  }
  widthTolerance(coil: CoilSheet) {
    if (coil.widthUpperTolerance != null && coil.widthUpperTolerance != undefined &&
      coil.widthLowerTolerance != null && coil.widthLowerTolerance != undefined &&
      coil.orderWidth != null && coil.orderWidth != undefined) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        const upperTolerance = Number(Math.round((coil.widthUpperTolerance + Utility.convertMillimeterToInch(coil.orderWidth)) * 1000) / 1000).toFixed(3);
        const lowerTolerance = Number(Math.round((Utility.convertMillimeterToInch(coil.orderWidth) - coil.widthLowerTolerance) * 1000) / 1000).toFixed(3);
        return ` ${lowerTolerance} - ${upperTolerance}`;

      } else {
        const upperTolerance = Number(Math.round((coil.widthUpperTolerance + coil.orderWidth) * 1000) / 1000).toFixed(2);
        const lowerTolerance = Number(Math.round((coil.orderWidth - coil.widthLowerTolerance) * 1000) / 1000).toFixed(2);
        return ` ${lowerTolerance} - ${upperTolerance}`;

      }
    } else {
      return ' ';
    }
  }

  thicknessTolerance(coil: CoilSheet) {
    if (coil.thicknessUpperTolerance != null && coil.thicknessUpperTolerance != undefined &&
      coil.thicknessLowerTolerance != null && coil.thicknessLowerTolerance != undefined &&
      coil.orderThickness != null && coil.orderThickness != undefined) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        const upperTolerance = Number(Math.round((coil.thicknessUpperTolerance + Utility.convertMillimeterToInch(coil.orderThickness)) * 1000) / 1000).toFixed(3);
        const lowerTolerance = Number(Math.round((Utility.convertMillimeterToInch(coil.orderThickness) - coil.thicknessLowerTolerance) * 1000) / 1000).toFixed(3);
        return ` ${lowerTolerance} - ${upperTolerance}`;
      } else {
        const upperTolerance = Number(Math.round((coil.thicknessUpperTolerance + coil.orderThickness) * 1000) / 1000).toFixed(2);
        const lowerTolerance = Number(Math.round((coil.orderThickness - coil.thicknessLowerTolerance) * 1000) / 1000).toFixed(2);
        return ` ${lowerTolerance} - ${upperTolerance}`;
      }

    } else {
      return ' ';
    }

  }


  onClose() {
    this.displayChange.emit(false);
    this.showCoilComparisonDialog = false;
  }

  // Work against memory leak if component is destroyed
  ngOnDestroy() {
    this.displayChange.unsubscribe();
  }

  setWidthTicknessGraphConfig() {
    let seriesData: { showInLegend: boolean, name: string, data: any }[] = [];
    let seriesColors: string[] = [];

    this.matchDataWithGraph.forEach((item) => {
      let graph: Graph | null = {};
      let matchDataGraph = item?.dataSet;
      graph = Utility.convertToGraph(JSON.stringify(matchDataGraph) || '');
      const chartData: any = [];
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        graph?.values?.forEach((arrayvalue, index) => {
          chartData.push([Utility.convertMeterToFeet(index), Utility.convertMillimeterToInch(arrayvalue)]);
        });
      } else {
        graph?.values?.forEach((arrayvalue, index) => {
          chartData.push([index, arrayvalue]);
        });
      }
      seriesData.push({ showInLegend: false, name: `Coil ${this.selectedGraph.label}  ${item?.coilSheetId}`, data: [...chartData] });
      if (item.colors) seriesColors.push(item?.colors);
    });
    this.setChartOptions2(seriesData, seriesColors);
    this.chartOptions1 = {
      series: seriesData,
      chart: {
        id: "chart11",
        type: "line",
        height: 230,
        width: '100%',
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: false,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: false,
          },
        },
      },
      responsive: [
        {
          breakpoint: undefined,
          options: {},
        }
      ],
      xaxis: {
        type: 'numeric',
        tickAmount: 20,
        position: 'bottom',
        labels: {
          rotate: 0,
          rotateAlways: false,
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        },
        decimalsInFloat: 0,
        title: {
          text: `Coil Length (${this.regionMeasurementUnits.length})`,
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#000000',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 300,
            cssClass: 'apexcharts-xaxis-title',
          },
        },
      },
      yaxis: {
        title: {
          text: `Coil ${this.selectedGraph.label} (${this.selectedGraph.key == "CROWN_GRAPH" || this.selectedGraph.key  == "WEDGE_GRAPH" ? this.regionMeasurementUnits.crown_wedge : this.regionMeasurementUnits.width_thickness})`,
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#000000',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 300,
            cssClass: 'apexcharts-xaxis-title',
          },
        },
      },
      colors: seriesColors,
      stroke: {
        width: 1,
        dashArray: 0
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        opacity: 1
      },
      markers: {
        size: 0
      },
      legend: {
        show: false,
      }
    };
  }

  setChartOptions2(chartData: any, seriesColors: string[]) {
    this.chartOptions2 = {
      series: chartData,
      chart: {
        id: "chart22",
        height: 130,
        width: '100%',
        type: "area",
        brush: {
          target: "chart11",
          enabled: true
        },
        selection: {
          enabled: true,
          xaxis: {
            min: 0,
            max: 100
          }
        }
      },
      xaxis: {
        type: 'numeric',
        tickAmount: 10,
        labels: {
          rotate: 0,
          rotateAlways: false,
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        },
        decimalsInFloat: 0,
      },
      stroke: {
        width: 1
      },
      colors: seriesColors,
      fill: {
        type: "gradient",
        gradient: {
          opacityFrom: 0.91,
          opacityTo: 0.1
        }
      },
      legend: {
        showForSingleSeries:true,
        show: true,
      }
    };
  }

  // chart logic
  /**
       * Called when drop down menu is clicked
       */
  onSelectGraphEvent(selectedGraph: { key: string; label: string; }) {
    this.matchDataWithGraph = [];
    this.selectedGraph = selectedGraph;
    this.selectedCoils.forEach((item) => {
      item.coilSheetDataSets?.forEach(data => {
        data.coilSheetId = item.coilSheetId;
        data.colors = item.colors;
        if (data.name === selectedGraph.key) {
          this.matchDataWithGraph.push(data);
        }
      });
    });
    this.setWidthTicknessGraphConfig();
  }

}